import {
  CircularProgress,
} from "@mui/material";

const AccessibleCircularProgress = (props) => {
  return (
    <CircularProgress aria-label="loading" role="status" {...props} />
  )
}

export default AccessibleCircularProgress